export default __webpack_public_path__ + "static/media/edit-icon-blue.09173b22.svg";